import "./App.scss";
import { PublicClientApplication } from "@azure/msal-browser";
import { config } from "../../../src/config";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom"; // ✅ ADD THIS
import AppContent from "./AppContent";
import { UserContextProvider } from "../../contexts/userContextApi";
function App() {
  const pca = new PublicClientApplication(config);

  return (
    <MsalProvider instance={pca}>
      <UserContextProvider>
        <BrowserRouter> {/* ✅ MUST be here */}
          <AppContent />
        </BrowserRouter>
      </UserContextProvider> 
    </MsalProvider>
  );
}

export default App;